export default __webpack_public_path__ + "static/media/skip-img.dbc845e0.png";